<!--<div [ngClass]=""
class="clamp-text"
>

</div>-->
<!--{{ _data }}-->

@if (loadNgContent) {
  <ng-content select="[dataComp]"></ng-content>
}

@if (!loadNgContent) {
  <span [innerHTML]="_data | safe: 'html'">
  </span>
}
